/*
  ZYBERON-GENERATED-FILE-DO-NOT-EDIT-BY-HAND
  This file was created by the Zyberon page builder. It is safe to delete.
  Editing it by hand is fine, but the next build will replace your changes.
*/
/* =============================================================================
   PRODUCT STORYTELLING SYSTEM — GLOBAL JS
   -----------------------------------------------------------------------------
   Vanilla JS, no dependencies. One small file for ALL sections.
   - Scroll animations via IntersectionObserver (respects reduced motion)
   - Module registry: sections register themselves here without this file
     needing to be rewritten.
   - Works correctly in the Theme Editor (shopify:section:load / :unload)

   ## THIS FILE MAY NEVER BREAK A MERCHANT'S THEME (2026-08-09)

   It runs inside somebody else's page, so it is written to be unable to do
   damage even when something in here is wrong:

     • ISOLATION. Every module runs inside a try/catch. A module that throws is
       logged once and skipped; the other modules, and the theme's own scripts,
       carry on. Before this, one bad querySelector took the whole file down and
       with it every animation on the page.
     • NO GLOBALS BUT ONE. Everything lives in a closure. `window.Storytelling`
       is the single name we take, and we bail out entirely if it already
       exists.
     • NOTHING LEAKS. Every listener, observer, interval and animation frame a
       module starts is registered for teardown and released on
       `shopify:section:unload`. In the theme editor a section reloads on every
       keystroke, and the old code left a timer behind each time.
     • NO WORK WE CANNOT DO. Every measurement guards against a zero width
       container (a section hidden by `hide_mobile`, a tab that is not visible),
       which is what used to turn a division into NaN.
   ========================================================================== */
(function () {
  'use strict';

  if (window.Storytelling) return; // prevent double loading

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------------- */
  /* Teardown registry                                                       */
  /* Every module gets a `ctx` with helpers that remember what they created,  */
  /* so a section reload in the theme editor releases all of it.              */
  /* ---------------------------------------------------------------------- */
  var teardowns = []; // { el: Element, fns: Function[] }

  function contextFor(el) {
    var fns = [];
    teardowns.push({ el: el, fns: fns });

    return {
      el: el,
      /** addEventListener that is removed again on unload. */
      on: function (target, type, handler, options) {
        if (!target || !target.addEventListener) return;
        target.addEventListener(type, handler, options);
        fns.push(function () { target.removeEventListener(type, handler, options); });
      },
      /** An interval that is cleared on unload. */
      interval: function (handler, ms) {
        var id = setInterval(handler, ms);
        fns.push(function () { clearInterval(id); });
        return id;
      },
      /** A timeout that is cleared on unload. */
      timeout: function (handler, ms) {
        var id = setTimeout(handler, ms);
        fns.push(function () { clearTimeout(id); });
        return id;
      },
      /** Any observer with a disconnect(). */
      observe: function (observer) {
        if (observer && observer.disconnect) {
          fns.push(function () { observer.disconnect(); });
        }
        return observer;
      },
      /** Anything else that has to stop. */
      cleanup: function (fn) { if (typeof fn === 'function') fns.push(fn); },
    };
  }

  function teardown(root) {
    for (var i = teardowns.length - 1; i >= 0; i--) {
      var entry = teardowns[i];
      // A detached node belongs to a section that is already gone.
      var stale = !entry.el || !entry.el.isConnected;
      var inside = root && root !== document && root.contains && root.contains(entry.el);
      if (!stale && !inside) continue;
      teardowns.splice(i, 1);
      for (var j = 0; j < entry.fns.length; j++) {
        try { entry.fns[j](); } catch (e) { /* a teardown may never throw */ }
      }
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Scroll animations                                                       */
  /* ---------------------------------------------------------------------- */
  var observer = null;

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('st-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );
    return observer;
  }

  function initAnimations(root) {
    root = root || document;
    if (reducedMotion.matches) {
      // Make visible immediately, no observer needed
      root.querySelectorAll('[data-st-animate] .st-anim').forEach(function (el) {
        el.classList.add('st-in-view');
      });
      return;
    }
    root.querySelectorAll('[data-st-animate] .st-anim').forEach(function (el) {
      if (el.classList.contains('st-in-view')) return;
      getObserver().observe(el);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Module registry — API for sections                                      */
  /* Usage: Storytelling.register('carousel', function (sectionEl, ctx) {})  */
  /* Sections mark themselves with data-st-module="carousel".                */
  /* ---------------------------------------------------------------------- */
  var modules = {};
  var warned = {};

  function initModules(root) {
    root = root || document;
    root.querySelectorAll('[data-st-module]').forEach(function (el) {
      var name = el.getAttribute('data-st-module');
      if (!modules[name] || el.hasAttribute('data-st-initialized')) return;
      el.setAttribute('data-st-initialized', '');
      try {
        modules[name](el, contextFor(el));
      } catch (err) {
        // One broken module never takes the page, or the theme, with it.
        if (!warned[name] && window.console && window.console.warn) {
          warned[name] = true;
          window.console.warn('[storytelling] module "' + name + '" failed', err);
        }
      }
    });
  }

  function initAll(root) {
    try { initAnimations(root); } catch (e) { /* animations are cosmetic */ }
    initModules(root);
  }

  window.Storytelling = {
    register: function (name, fn) {
      modules[name] = fn;
      initModules(document);
    },
    init: initAll,
  };

  /* ---------------------------------------------------------------------- */
  /* Boot + Theme Editor support                                             */
  /* ---------------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    teardown(e.target);
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    teardown(e.target);
  });
})();

/* =============================================================================
   MODULE: carousel — used by st-before-after-carousel, st-review-slider and
   the before/after grid in its carousel layout.

   Native scroll-snap does the heavy lifting; JS adds buttons, dots, keyboard
   access and the optional autoplay. Everything is opt in through data
   attributes written by the section, so a section that wants a plain grid
   simply does not set them.

     data-st-track        the scrolling element (required)
     data-st-prev/-next   arrow buttons (optional)
     data-st-dots         dot container (optional)
     data-st-autoplay     seconds between advances; absent or 0 means off
     data-st-loop         "true" to wrap around at either end
     data-st-pause-hover  "true" to pause while hovered or focused

   Autoplay is deliberately conservative. It never runs when the visitor asked
   for reduced motion, it stops while the section is off screen or the tab is
   in the background, it stops for good on the first manual interaction, and it
   is cleared on section unload. An advert that keeps sliding behind a
   customer's back is worse than no advert.
   ========================================================================== */
window.Storytelling.register('carousel', function (root, ctx) {
  'use strict';

  var track = root.querySelector('[data-st-track]');
  if (!track) return;

  var prev = root.querySelector('[data-st-prev]');
  var next = root.querySelector('[data-st-next]');
  var dotsWrap = root.querySelector('[data-st-dots]');
  var dots = [];
  var pages = 1;
  var ticking = false;

  var autoplayMs = Math.round(parseFloat(root.getAttribute('data-st-autoplay') || '0') * 1000);
  if (!isFinite(autoplayMs) || autoplayMs < 1000) autoplayMs = 0;
  var loop = root.getAttribute('data-st-loop') === 'true';
  // The section always writes this attribute, true or false. Absent means an
  // older page that never had the setting, and pausing is the safer default.
  var pauseOnHover = root.getAttribute('data-st-pause-hover') !== 'false';

  /* Its own query, deliberately. A registered module is a top level callback,
     OUTSIDE the boot closure at the head of this file, so the `reducedMotion`
     declared up there is not in scope here. Reaching for it throws a
     ReferenceError, and because every module now runs inside a try/catch that
     would not crash the page: it would silently leave this carousel with no
     arrows, no dots and no autoplay, on every product page, with nothing but a
     console warning to say so. The timeline module below does the same thing
     for the same reason. */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** Scrolling honours the visitor's motion preference, like the CSS already does. */
  function scrollBehavior() {
    return reducedMotion.matches ? 'auto' : 'smooth';
  }

  /** Never 0: a hidden or not yet laid out track would turn every ratio into NaN. */
  function pageWidth() {
    var w = track.clientWidth;
    return w > 0 ? w : 1;
  }

  function maxScroll() {
    var m = track.scrollWidth - track.clientWidth;
    return m > 0 ? m : 0;
  }

  function currentPage() {
    var p = Math.round(track.scrollLeft / pageWidth());
    if (!isFinite(p) || p < 0) p = 0;
    return Math.min(pages - 1, p);
  }

  function buildDots() {
    var max = maxScroll();
    pages = max > 4 ? Math.round(max / pageWidth()) + 1 : 1;
    if (!isFinite(pages) || pages < 1) pages = 1;

    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    dots = [];
    if (pages < 2) return;

    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'st-carousel__dot';
      dot.setAttribute('aria-label', i + 1 + ' / ' + pages);
      (function (index) {
        dot.addEventListener('click', function () {
          stopAutoplay();
          track.scrollTo({ left: index * pageWidth(), behavior: scrollBehavior() });
        });
      })(i);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }

  function update() {
    var page = currentPage();
    var max = maxScroll();

    dots.forEach(function (d, i) {
      if (i === page) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    // A looping carousel can always go both ways, so it never greys an arrow
    // out. It is still greyed out when there is nothing to scroll AT ALL,
    // because two live-looking arrows that do nothing are worse than none.
    var nowhereToGo = max <= 4;
    if (prev) prev.disabled = nowhereToGo || (!loop && track.scrollLeft <= 4);
    if (next) next.disabled = nowhereToGo || (!loop && track.scrollLeft >= max - 4);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }

  function go(direction) {
    var max = maxScroll();
    if (loop) {
      if (direction > 0 && track.scrollLeft >= max - 4) {
        track.scrollTo({ left: 0, behavior: scrollBehavior() });
        return;
      }
      if (direction < 0 && track.scrollLeft <= 4) {
        track.scrollTo({ left: max, behavior: scrollBehavior() });
        return;
      }
    }
    track.scrollBy({ left: direction * pageWidth(), behavior: scrollBehavior() });
  }

  /* ---- Autoplay ---------------------------------------------------------- */
  var timer = null;
  var visible = true;
  var hovered = false;
  var stopped = false;

  function tick() {
    if (stopped || !visible || hovered || document.hidden) return;
    // Without loop, stop at the end rather than jittering against the edge.
    if (!loop && track.scrollLeft >= maxScroll() - 4) { stopAutoplay(); return; }
    go(1);
  }

  function startAutoplay() {
    if (!autoplayMs || stopped || timer || reducedMotion.matches) return;
    timer = ctx.interval(tick, autoplayMs);
  }

  function stopAutoplay() {
    stopped = true;
    if (timer) { clearInterval(timer); timer = null; }
  }

  if (autoplayMs && !reducedMotion.matches) {
    if ('IntersectionObserver' in window) {
      ctx.observe(
        (function () {
          var io = new IntersectionObserver(
            function (entries) { visible = entries[0].isIntersecting; },
            { threshold: 0.2 }
          );
          io.observe(root);
          return io;
        })()
      );
    }
    if (pauseOnHover) {
      ctx.on(root, 'pointerenter', function () { hovered = true; });
      ctx.on(root, 'pointerleave', function () { hovered = false; });
      ctx.on(root, 'focusin', function () { hovered = true; });
      ctx.on(root, 'focusout', function () { hovered = false; });
    }
    // A real swipe or drag means the customer is driving now. A WHEEL event is
    // only that when it is horizontal: scrolling the page vertically with the
    // pointer over the carousel fires wheel on the track too, and treating that
    // as intent used to kill autoplay on almost every visit.
    ctx.on(track, 'pointerdown', stopAutoplay);
    ctx.on(track, 'touchstart', stopAutoplay, { passive: true });
    ctx.on(track, 'wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stopAutoplay();
    }, { passive: true });
    startAutoplay();
  }

  /* ---- Controls ---------------------------------------------------------- */
  if (prev) ctx.on(prev, 'click', function () { stopAutoplay(); go(-1); });
  if (next) ctx.on(next, 'click', function () { stopAutoplay(); go(1); });

  // Keyboard: the track is focusable in the markup, so arrows should work.
  ctx.on(track, 'keydown', function (e) {
    if (e.key === 'ArrowRight') { stopAutoplay(); go(1); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { stopAutoplay(); go(-1); e.preventDefault(); }
  });

  ctx.on(track, 'scroll', onScroll, { passive: true });

  var resizeTimer;
  ctx.on(window, 'resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { buildDots(); update(); }, 150);
  });
  ctx.cleanup(function () { clearTimeout(resizeTimer); });

  // The first layout can land before images have a size. One re-measure after
  // load keeps the dot count honest without polling.
  ctx.on(window, 'load', function () { buildDots(); update(); });

  if ('ResizeObserver' in window) {
    // Rebuilding the dots changes the page height, which can toggle the window
    // scrollbar, which resizes the track again. Only a genuine width change is
    // acted on, so the observer cannot drive itself in a loop.
    var lastWidth = -1;
    ctx.observe(
      (function () {
        var ro = new ResizeObserver(function () {
          var w = track.clientWidth;
          if (w === lastWidth) return;
          lastWidth = w;
          buildDots();
          update();
        });
        ro.observe(track);
        return ro;
      })()
    );
  }

  buildDots();
  update();
});

/* =============================================================================
   MODULE: product — used by st-product-hero
   Gallery thumbnails plus offer selection. On a variant switch an
   'st:variant:change' event is dispatched on document so other sections
   (such as the sticky bar) can listen in without a direct coupling.
   ========================================================================== */
window.Storytelling.register('product', function (root, ctx) {
  'use strict';

  /* Gallery */
  var thumbs = root.querySelectorAll('[data-st-thumb]');
  var slides = root.querySelectorAll('[data-st-slide]');
  thumbs.forEach(function (thumb) {
    ctx.on(thumb, 'click', function () {
      var id = thumb.getAttribute('data-st-thumb');
      thumbs.forEach(function (t) {
        if (t === thumb) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-st-slide') === id);
      });
    });
  });

  /* Offers, set the hidden variant id in the form */
  var offers = root.querySelectorAll('[data-st-offer] input[type="radio"]');
  var idInputs = root.querySelectorAll('form [name="id"]');

  function selectOffer(input) {
    var card = input.closest('[data-st-offer]');
    root.querySelectorAll('[data-st-offer]').forEach(function (c) {
      c.classList.toggle('is-selected', c === card);
    });
    idInputs.forEach(function (el) { el.value = input.value; });
    document.dispatchEvent(new CustomEvent('st:variant:change', {
      detail: {
        id: input.value,
        title: input.getAttribute('data-st-title') || '',
        price: input.getAttribute('data-st-price') || ''
      }
    }));
  }

  offers.forEach(function (input) {
    ctx.on(input, 'change', function () { selectOffer(input); });
    if (input.checked) selectOffer(input);
  });
});

/* =============================================================================
   MODULE: sticky — used by st-sticky-atc
   Appears as soon as the hero (or the first .st-section) scrolls out of view.

   The bar has NO /cart/add form of its own. A form of its own would lock in
   the variant id at render time; if the customer then switches variant in
   the theme's buy box, the bar would add the WRONG variant (the theme does
   not fire 'st:variant:change'. Only st-product-hero did that, and we do not
   install that here, so the theme's buy box stays intact).

   Instead, the button is a PROXY onto the theme's own add to cart. The
   theme then handles variant, quantity, validation and its own cart drawer.
   ========================================================================== */
window.Storytelling.register('sticky', function (root, ctx) {
  'use strict';

  var bar = root.querySelector('.st-sticky');
  if (!bar) return;

  /* ---- Visibility ----------------------------------------------------------

     "Scrolled out of view" has to mean ABOVE the viewport, not merely absent
     from it. `.st-hero` belongs to st-product-hero, which this pack never
     installs (it is in ALWAYS_FORBIDDEN), so the sentinel is always the first
     storytelling section, and that sits BELOW a full product buy box. A
     sentinel below the fold is "not intersecting" too, and IntersectionObserver
     always delivers one observation immediately, so the old test slid the bar
     in at first paint and then hid it again once the shopper actually reached
     that section. Precisely inverted, and a fixed bar pinned over the bottom of
     somebody's storefront from the moment it renders.

     Checking that the sentinel's top is above the viewport fixes both halves
     and keeps working unchanged if `.st-hero` ever comes back.
  --------------------------------------------------------------------------- */
  var sentinel = document.querySelector('.st-hero') || document.querySelector('.st-section');
  if (sentinel && 'IntersectionObserver' in window) {
    ctx.observe(
      (function () {
        var io = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0 });
        io.observe(sentinel);
        return io;
      })()
    );
  } else {
    ctx.on(window, 'scroll', function () {
      bar.classList.toggle('is-visible', window.scrollY > 500);
    }, { passive: true });
  }

  /* ---- The theme's buy box is the single source of truth ------------------ */
  function themeForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!bar.contains(forms[i])) return forms[i];
    }
    return null;
  }

  function themeAddButton(form) {
    if (!form) return null;
    return form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
  }

  /* ---- Button: click the theme's ATC ---------------------------------------- */
  var btn = bar.querySelector('[data-st-sticky-add]');
  if (btn) {
    ctx.on(btn, 'click', function () {
      var form = themeForm();
      var add = themeAddButton(form);
      /* Sold out/disabled: do not secretly post anyway, send to the buy box instead. */
      if (add && !add.disabled) {
        add.click();
        return;
      }
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- The subline follows the theme's variant selection -------------------- */
  var subEl = bar.querySelector('[data-st-sticky-sub]');
  var titles = {};
  try {
    var raw = root.querySelector('[data-st-variant-titles]');
    if (raw) titles = JSON.parse(raw.textContent || '{}') || {};
  } catch (e) {
    titles = {};
  }

  function syncSub() {
    if (!subEl) return;
    var form = themeForm();
    var input = form && form.querySelector('[name="id"]');
    var title = input && titles[String(input.value)];
    if (title) subEl.textContent = title;
  }

  /* Themes set the hidden id as a PROPERTY (no event, no attribute
     mutation), and some (Dawn) redraw the whole form. So we listen
     broadly: bubbling change from the variant picker, our own hero event, and
     a MutationObserver for the section re-rendering. We only read the
     input on the next frame, once the theme has updated it. */
  ctx.on(document, 'change', function (e) {
    if (bar.contains(e.target)) return;
    if (window.requestAnimationFrame) window.requestAnimationFrame(syncSub);
    else setTimeout(syncSub, 0);
  });

  ctx.on(document, 'st:variant:change', function (e) {
    if (subEl && e.detail && e.detail.title) subEl.textContent = e.detail.title;
  });

  if ('MutationObserver' in window) {
    var form = themeForm();
    var container = form && (form.closest('[id^="shopify-section"]') || form.parentNode);
    if (container) {
      ctx.observe(
        (function () {
          var mo = new MutationObserver(syncSub);
          mo.observe(container, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value'],
          });
          return mo;
        })()
      );
    }
  }

  syncSub();
});

/* =============================================================================
   MODULE: timeline — used by st-how-it-works
   Vertical timeline with scroll progress. Sets --st-progress (0 to 1) on the
   timeline so the accent line grows along with it, and marks the matching steps
   as .is-active. Fully rAF-based and respects prefers-reduced-motion: with
   reduced motion the line is immediately full and all steps are active.
   ========================================================================== */
window.Storytelling.register('timeline', function (root, ctx) {
  'use strict';

  var line = root.querySelector('[data-st-timeline]');
  if (!line) return;

  var steps = Array.prototype.slice.call(line.querySelectorAll('.st-tl-step'));

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    line.style.setProperty('--st-progress', '1');
    steps.forEach(function (s) { s.classList.add('is-active'); });
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;
    var rect = line.getBoundingClientRect();
    if (rect.height <= 0) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    /* The line "fills" to about 55% of the viewport height. */
    var anchor = vh * 0.55;
    var p = (anchor - rect.top) / rect.height;
    if (p < 0) p = 0; else if (p > 1) p = 1;
    line.style.setProperty('--st-progress', p.toFixed(4));

    var fillPx = p * rect.height;
    steps.forEach(function (step) {
      step.classList.toggle('is-active', step.offsetTop <= fillPx + 6);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  ctx.on(window, 'scroll', onScroll, { passive: true });
  ctx.on(window, 'resize', onScroll, { passive: true });
  update();
});

/* =============================================================================
   MODULE: cause — used by st-cause-profonde
   Benefit buttons switch the PROBLEM + HOW IT WORKS panel. The text
   comes from data attributes (data-problem / data-how) and is set as
   textContent, so it is never interpreted as HTML (no injection).
   ========================================================================== */
window.Storytelling.register('cause', function (root, ctx) {
  'use strict';

  var btns = Array.prototype.slice.call(root.querySelectorAll('[data-st-cause-btn]'));
  if (!btns.length) return;

  var problemEl = root.querySelector('[data-st-cause-problem]');
  var howEl = root.querySelector('[data-st-cause-how]');
  var problemRow = root.querySelector('[data-st-cause-problem-row]');
  var howRow = root.querySelector('[data-st-cause-how-row]');

  function activate(btn) {
    btns.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var problem = btn.getAttribute('data-problem') || '';
    var how = btn.getAttribute('data-how') || '';
    if (problemEl) problemEl.textContent = problem;
    if (howEl) howEl.textContent = how;
    if (problemRow) problemRow.hidden = problem === '';
    if (howRow) howRow.hidden = how === '';
  }

  btns.forEach(function (btn) {
    ctx.on(btn, 'click', function () { activate(btn); });
  });

  /* Show the first benefit by default. */
  activate(btns[0]);
});

/* =============================================================================
   MODULE: countdown — used by st-offer-bar
   Only counts down to a REAL end date entered by the merchant. When the
   timer runs out, the bar disappears (no invented or restarting scarcity).
   The optional progress bar shows the elapsed part of the promo window, and
   ONLY when there is both a start date and a (future) end date.
   ========================================================================== */
window.Storytelling.register('countdown', function (root, ctx) {
  'use strict';

  var el = root.querySelector('[data-st-countdown]');
  if (!el) return;

  var end = parseInt(el.getAttribute('data-st-end'), 10);
  if (!end || isNaN(end)) return;

  var start = parseInt(el.getAttribute('data-st-start'), 10);
  if (isNaN(start)) start = 0;

  var bar = root.querySelector('.st-offerbar');
  var progress = root.querySelector('[data-st-offer-progress]');
  var dd = el.querySelector('[data-cd-d]');
  var hh = el.querySelector('[data-cd-h]');
  var mm = el.querySelector('[data-cd-m]');
  var ss = el.querySelector('[data-cd-s]');
  var timer = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var now = Date.now();
    var rem = end - now;
    if (rem <= 0) {
      if (timer) clearInterval(timer);
      if (bar) bar.style.display = 'none';
      return;
    }
    var s = Math.floor(rem / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    if (dd) dd.textContent = d;
    if (hh) hh.textContent = pad(h);
    if (mm) mm.textContent = pad(m);
    if (ss) ss.textContent = pad(s);
    if (progress && start && end > start) {
      var frac = (now - start) / (end - start);
      if (frac < 0) frac = 0; else if (frac > 1) frac = 1;
      progress.style.setProperty('--st-offer-progress', frac.toFixed(4));
    }
  }

  /* Registered through ctx, so a section reload in the theme editor can never
     leave a second timer running behind the first. */
  timer = ctx.interval(tick, 1000);
  tick();
});

/* =============================================================================
   MODULE: painreviews — used by st-pain-reviews

   A pill per pain point, three review cards under the selected one. The panels
   are all in the DOM, so the copy is there for a crawler and for a visitor
   whose JS never arrives; this module's first act is to hide the ones that are
   not selected. That ordering matters: if it never runs, the page degrades to
   an honest long list rather than a widget stuck on nothing.

   Dots are built per panel and only when the cards actually overflow, which on
   this section means the mobile viewport. On desktop the cards are a grid, so
   there is nothing to page through and no dots are created.
   ========================================================================== */
window.Storytelling.register('painreviews', function (root, ctx) {
  'use strict';

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-st-pp-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-st-pp-panel]'));
  if (!panels.length) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function show(index) {
    panels.forEach(function (p) {
      p.classList.toggle('is-hidden', p.getAttribute('data-st-pp-panel') !== String(index));
    });
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-st-pp-tab') === String(index);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    // A panel that was display:none has no measurable width, so its dots can
    // only be built once it is on screen.
    var live = panels[Number(index)];
    if (live) buildDots(live);
  }

  /* ---- Per panel dots ----------------------------------------------------- */
  function buildDots(panel) {
    var track = panel.querySelector('.st-pp__cards');
    var wrap = panel.querySelector('[data-st-pp-dots]');
    if (!track || !wrap) return;

    var width = track.clientWidth > 0 ? track.clientWidth : 1;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 4) { wrap.innerHTML = ''; return; } // a grid, or one card: nothing to page

    var cards = track.children.length;
    if (wrap.childElementCount === cards) return; // already built for this layout

    wrap.innerHTML = '';
    for (var i = 0; i < cards; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'st-pp__dot';
      dot.setAttribute('aria-label', i + 1 + ' / ' + cards);
      if (i === 0) dot.setAttribute('aria-current', 'true');
      (function (index) {
        dot.addEventListener('click', function () {
          var card = track.children[index];
          if (card) {
            track.scrollTo({
              left: card.offsetLeft - track.offsetLeft,
              behavior: reducedMotion.matches ? 'auto' : 'smooth',
            });
          }
        });
      })(i);
      wrap.appendChild(dot);
    }

    if (!track.hasAttribute('data-st-pp-bound')) {
      track.setAttribute('data-st-pp-bound', '');
      var ticking = false;
      ctx.on(track, 'scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth > 0 ? track.clientWidth : 1;
          var current = Math.round(track.scrollLeft / (track.scrollWidth / track.children.length || w));
          Array.prototype.forEach.call(wrap.children, function (d, i) {
            if (i === current) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
        });
      }, { passive: true });
    }
  }

  tabs.forEach(function (t) {
    ctx.on(t, 'click', function () { show(t.getAttribute('data-st-pp-tab')); });
    // Left/right move between pills, which is what a tablist is expected to do.
    ctx.on(t, 'keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = tabs.indexOf(t);
      var next = tabs[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (!next) return;
      e.preventDefault();
      next.focus();
      show(next.getAttribute('data-st-pp-tab'));
    });
  });

  var resizeTimer;
  ctx.on(window, 'resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var live = root.querySelector('.st-pp__panel:not(.is-hidden)');
      if (live) buildDots(live);
    }, 150);
  });
  ctx.cleanup(function () { clearTimeout(resizeTimer); });

  show(tabs.length ? tabs[0].getAttribute('data-st-pp-tab') : 0);
});
